import { Spin } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import QuizzesFilters from "../../../QuizStudio/component/pages/QuizzesLibrary/QuizzesFilters";

import {
  getQuizTestsList,
} from "../../../QuizStudio/actions";
import AssessmentCard from "./AssessmentCard";
import AssessmentCardVerified from "./AssessmentCardVerified";

const AssessmentSkillTest = () => {
  const dispatch = useDispatch();
  const {
    quizTestsList,
    quizTestsListLoading,
  } = useSelector((state) => state.quizTest);

  var testUser = JSON.parse(localStorage.getItem("userDetails"));
  const currentUserId = testUser?._id;

  useEffect(() => {
    if (currentUserId) {
      dispatch(getQuizTestsList());
    }
  }, [currentUserId, dispatch]);

  return (
    <>
      <div className='col-12 px-0 pt-3'>
        <div className='row mx-0 Assessment-cards-section'>
          <div className='col-12'>
            <div className='row mx-0 px-lg-5 py-4'>
              <div className="col-12 px-0">
                <Link
                  to='/quiz'
                  className='text-decoration-none text-muted back-hover fw-semibold cursor-pointer d-flex pb-2 align-items-center'
                >
                  <i className='bi bi-arrow-left me-2'></i>
                  Back
                </Link>
                <h1 className='ps-1 py-5 fw-bolder text-white'>Skill Assessments</h1>
                <QuizzesFilters />
              </div>
              <div className='row rounded-1 mx-0 py-3 px-0 '>
                {quizTestsListLoading ? (
                  <div className='text-center w-100 py-5'>
                    <Spin />
                  </div>
                ) : (
                  <>
                    <div className='col-12 p-3 text-white border-0 assessment-card-A rounded-5 bg-default'>
                      <AssessmentCardVerified
                        quizTestsList={quizTestsList}
                      />
                    </div>
                    <div className='col-12 pt-4 mt-3 p-3 text-white border-0 assessment-card-A rounded-5 bg-default'>
                      <AssessmentCard
                        quizTestsList={quizTestsList}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AssessmentSkillTest;
